import React from "react";

const CrmSelectField = ({ label, options, value, onChange, name }) => {
    return (
        <div>
            <label className="block font-semibold uppercase text-[14px] text-gray-700">
                {label}</label>
            <select
                name={name}
                value={value}
                onChange={onChange}
                className="w-full p-2 border border-gray-300 rounded mt-2"
            >
                <option value="">Select {label}</option>
                {options.map((opt, idx) => (
                    <option key={idx} value={opt}>{opt}</option>
                ))}
            </select>
        </div>
    );
};

export default CrmSelectField;
